import { render } from "./ClientDemographicComponent.vue?vue&type=template&id=6d81cbc9&scoped=true"
import script from "./ClientDemographicComponent.vue?vue&type=script&lang=js"
export * from "./ClientDemographicComponent.vue?vue&type=script&lang=js"

import "./ClientDemographicComponent.vue?vue&type=style&index=0&id=6d81cbc9&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d81cbc9"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QBtn,QInnerLoading});
